import { customBaseUrl, httpGet, httpPost, httpPut, httpDelete, httpPostFormData } from "../../store/http";

const { communicationUrl, authUrl } = customBaseUrl;

export const getAllCampaigns = async () => {
  return await httpGet(`${communicationUrl}/campaigns`);
};

export const getActiveCampaigns = async () => {
  return await httpGet(`${communicationUrl}/campaigns/active`);
};

export const getCampaignById = async (id) => {
  return await httpGet(`${communicationUrl}/campaigns/${id}`);
};

export const createCampaign = async (payload) => {
  return await httpPost(`${communicationUrl}/campaigns`, payload);
};

export const updateCampaign = async (id, payload) => {
  return await httpPut(`${communicationUrl}/campaigns/${id}`, payload);
};

export const deleteCampaign = async (id) => {
  return await httpDelete(`${communicationUrl}/campaigns/${id}`);
};

export const pauseCampaign = async (id) => {
  return await httpPut(`${communicationUrl}/campaigns/${id}/pause`, {});
};

export const resumeCampaign = async (id) => {
  return await httpPut(`${communicationUrl}/campaigns/${id}/resume`, {});
};

export const uploadCampaignImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const url = `${authUrl}/files/upload?documentType=PROMOTION&username=promotion&folderName=promotion`;
  return await httpPostFormData(url, formData);
};
